import { useTeam } from 'app/frontend/base/config/context/team'
import PremiumBenefits from 'app/frontend/base/pages/GuildDashboard/components/PremiumBenefits'

const PremiumSection = () => {
  const { guild } = useTeam()

  return (
    <div>
      <PremiumBenefits
        guild={guild}
        legacyTier={guild.legacyPatron?.details?.pledge_tier}
        benefits={guild.premiumBenefits || []}
      />
    </div>
  )
}

export default PremiumSection
